export const services = [
  {
    slug: "raccoons-opossums",
    title: "Raccoons & Opossums",
    tagline: "The Uninvited Houseguests",
    icon: "Squirrel",
    image: "https://images.unsplash.com/photo-1688521307536-faa6ca53b667?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxyYWNjb29uJTIwdHJlZXxlbnwwfHx8fDE3NzQwMzcyNDZ8MA&ixlib=rb-4.1.0&q=85",
    shortDesc: "Smart, strong, and absolutely terrible roommates. We trap, remove, and seal them out for good.",
    fullDesc: "Raccoons are smart, strong, and absolutely terrible roommates. They'll tear through your roof, set up a nursery in your attic, and leave a biohazard behind when they're done. Opossums aren't much better. If you're hearing thumping, scratching, or what sounds like a small toddler running laps above your bedroom at 3am — that's your cue to call us.",
    handles: [
      "Trapping & removal",
      "Entry point identification",
      "Attic cleanup & decontamination",
      "Full seal-off so they can't come back"
    ],
    metaTitle: "Raccoon & Opossum Removal | St. Augustine, FL | Double D Trapping",
    metaDescription: "Professional raccoon and opossum trapping and removal in St. Augustine, St. Johns County, and Flagler County FL. 50 years experience. Licensed & insured. Call 904-237-6253."
  },
  {
    slug: "rodents",
    title: "Rodents — Rats & Mice",
    tagline: "Small Problem. Big Damage.",
    icon: "Bug",
    image: "https://images.unsplash.com/photo-1751105539468-04e39118428a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxyYXQlMjByb2RlbnQlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc3NDAzNzM1NXww&ixlib=rb-4.1.0&q=85",
    shortDesc: "A rat can chew through wiring and have a family of 40 before you know they're there.",
    fullDesc: "Don't let the size fool you. A rat can chew through electrical wiring, contaminate your insulation, and have a family of 40 before you even know they're there. Mice are worse — they fit through a hole the size of a dime. If you've heard scratching in the walls or found droppings in your pantry, the clock is already ticking.",
    handles: [
      "Full property inspection",
      "Trapping & removal",
      "Long-term exclusion sealing so they can't find their way back in"
    ],
    metaTitle: "Rat & Mouse Removal | St. Augustine, FL | Double D Trapping",
    metaDescription: "Expert rodent control and removal in St. Augustine, St. Johns County, and Flagler County FL. Full inspection, trapping, and exclusion sealing. Call 904-237-6253."
  },
  {
    slug: "wild-hogs",
    title: "Wild Hog Removal",
    tagline: "This Isn't a Neighborhood Pet Situation.",
    icon: "AlertTriangle",
    image: "https://images.pexels.com/photos/7625532/pexels-photo-7625532.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    shortDesc: "Federally licensed hog removal. Aggressive, destructive, 400+ pounds. We handle it.",
    fullDesc: "Wild hogs are aggressive, destructive, and can weigh over 400 pounds. They'll destroy a yard overnight, threaten your pets, and carry diseases dangerous to your family. This isn't a job for just anyone — it requires federal-level licensing and real experience. Good thing that's exactly what we have.\n\nDouble D Trapping LLC holds Federal Swine Dealers License #FL 04513-16 and operates a Certified Swine Facility — making us one of the only operators in the region qualified to handle large-scale hog removal the right way.",
    handles: [
      "Sounder (group) trapping",
      "Large property hog control",
      "Emergency removal",
      "Full compliance with federal and state regulations"
    ],
    cta: "Hogs on your property? Call 904-237-6253 right now. We don't mess around with these.",
    featured: true,
    metaTitle: "Wild Hog Removal | Federal Licensed | St. Augustine, FL | Double D Trapping",
    metaDescription: "Federally licensed wild hog removal in St. Augustine, St. Johns County, and Flagler County FL. Federal Swine Dealers License #FL 04513-16. Call 904-237-6253."
  },
  {
    slug: "squirrels",
    title: "Squirrels",
    tagline: "Cute From a Distance. Nightmare Up Close.",
    icon: "TreePine",
    image: "https://images.unsplash.com/photo-1615125965946-9a5ca7a488dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxzcXVpcnJlbCUyMHRyZWUlMjB3aWxkbGlmZXxlbnwwfHx8fDE3NzQwMzczNTB8MA&ixlib=rb-4.1.0&q=85",
    shortDesc: "They chew through wiring and nest in insulation. House fires have started this way.",
    fullDesc: "Squirrels look harmless until they're in your attic chewing through electrical wiring and nesting in your insulation. House fires have started this way. If you're seeing squirrels running your roofline or hearing fast scurrying and scratching during the day — don't wait on this one.",
    handles: [
      "Humane trapping",
      "Eave and roofline entry repair",
      "Full exclusion to keep them out for good"
    ],
    metaTitle: "Squirrel Removal | St. Augustine, FL | Double D Trapping",
    metaDescription: "Professional squirrel trapping and removal in St. Augustine, St. Johns County, and Flagler County FL. Humane methods, full exclusion. Call 904-237-6253."
  },
  {
    slug: "bats",
    title: "Bats",
    tagline: "Protected by Law. Removed by Professionals.",
    icon: "Moon",
    image: "https://images.unsplash.com/photo-1667379861537-589bcd302f0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxiYXQlMjBmbHlpbmclMjBkYXJrJTIwbmlnaHR8ZW58MHx8fHwxNzc0MDM3MzUyfDA&ixlib=rb-4.1.0&q=85",
    shortDesc: "Federally protected. Requires a licensed specialist for legal exclusion in Florida.",
    fullDesc: "Bats are federally protected, which means you can't just \"get rid of them.\" It takes a licensed specialist who knows exactly how and when exclusion is legal in Florida. We do. Beyond the legal side — a bat colony in your attic leaves behind guano that's a serious respiratory hazard. This one needs to be done right.",
    handles: [
      "Legal exclusion (no harm to the bats)",
      "Colony removal",
      "Full attic decontamination and guano cleanup"
    ],
    metaTitle: "Bat Removal & Exclusion | St. Augustine, FL | Double D Trapping",
    metaDescription: "Licensed bat exclusion and removal in St. Augustine, St. Johns County, and Flagler County FL. Legal, humane methods. Full decontamination. Call 904-237-6253."
  },
  {
    slug: "armadillos-moles",
    title: "Armadillos & Moles",
    tagline: "Your Yard Called. It's Not Happy.",
    icon: "Shovel",
    image: "https://images.unsplash.com/photo-1766798610980-1a92cb8691cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxhcm1hZGlsbG8lMjB3aWxkbGlmZSUyMG5hdHVyZXxlbnwwfHx8fDE3NzQwMzczNTN8MA&ixlib=rb-4.1.0&q=85",
    shortDesc: "They'll dig up your yard overnight. Trapping takes patience and the right setup.",
    fullDesc: "You worked hard on that lawn. Armadillos and moles don't care. They'll dig it up overnight looking for grubs and bugs, leaving holes, tunnels, and a yard that looks like a construction zone. Trapping these guys takes patience and knowhow — they're not easy to catch without the right setup.",
    handles: [
      "Targeted trapping",
      "Yard damage assessment",
      "Prevention strategies to keep them from coming back"
    ],
    metaTitle: "Armadillo & Mole Removal | St. Augustine, FL | Double D Trapping",
    metaDescription: "Professional armadillo and mole trapping in St. Augustine, St. Johns County, and Flagler County FL. Yard repair and prevention. Call 904-237-6253."
  },
  {
    slug: "attic-sanitation",
    title: "Attic Sanitation & Decontamination",
    tagline: "Trapping the Animal Was Step One. Now Let's Talk About What They Left Behind.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1600877841576-a867b59777b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxhdHRpYyUyMGluc3VsYXRpb24lMjBob21lJTIwcmVwYWlyfGVufDB8fHx8MTc3NDAzNzM1Nnww&ixlib=rb-4.1.0&q=85",
    shortDesc: "Urine-soaked insulation, droppings, pheromone trails. We clean it all.",
    fullDesc: "Here's what most people don't think about — after the animal is gone, your attic is still a crime scene. Urine-soaked insulation. Droppings full of bacteria. Pheromone trails that act like a neon \"vacancy\" sign to the next animal that comes along. If you skip this step, you might as well flip on the Vacancy sign and leave the light on.",
    steps: [
      { title: "Remove the Mess", desc: "We safely bag and remove all contaminated insulation, droppings, and nesting material. Full hazmat approach — no shortcuts." },
      { title: "Disinfect & Sanitize", desc: "Industrial-strength, pet-safe disinfectants kill bacteria, viruses, and fungi left behind by the animal. The same stuff professionals use. Because we are professionals." },
      { title: "Neutralize the Scent Trails", desc: "This is the step most people skip and then wonder why they have another animal six months later. We eliminate the pheromone trails that tell other wildlife your attic is a good, safe spot to live." },
      { title: "Replace Your Insulation", desc: "Damaged insulation doesn't just smell — it costs you money every month in lost energy efficiency. We replace it clean, fresh, and up to standard." }
    ],
    handles: [],
    metaTitle: "Attic Sanitation & Decontamination | St. Augustine, FL | Double D Trapping",
    metaDescription: "Complete attic sanitation, decontamination, and insulation replacement in St. Augustine, St. Johns County, and Flagler County FL. 50 years experience. Call 904-237-6253."
  }
];

export const faqData = [
  {
    q: "How fast can you get here?",
    a: "Fast. We offer 24/7 emergency response throughout St. Johns and Flagler counties. Wildlife doesn't punch a clock and neither do we. Call 904-237-6253 and D. Davis picks up — not a call center, not a voicemail."
  },
  {
    q: "Do you fix the damage the animals caused?",
    a: "Absolutely. Trapping is just the beginning. We offer full seal-offs to close every entry point, plus attic sanitation and insulation replacement to get your home back to the way it was — or better."
  },
  {
    q: "Are you licensed for wild hogs?",
    a: "Yes — and this matters more than people realize. We hold a Federal Swine Dealers License (#FL 04513-16) and operate a Certified Swine Facility. Most trappers in Florida are not qualified for this. We are."
  },
  {
    q: "Is this going to be expensive?",
    a: "Every job is different depending on the animal, the damage, and the scope of work. That's why we offer free quotes — fill out the form, send us a photo, and we'll give you a straight answer with no runaround."
  },
  {
    q: "What if the animal comes back?",
    a: "Our seal-offs are guaranteed. If something gets back in through a point we sealed and repaired, we come back and make it right. Simple as that."
  },
  {
    q: "Do you serve my area?",
    a: "We serve St. Augustine, St. Johns County, Flagler County, and surrounding areas. Not sure if you're in range? Call or text 904-237-6253 and we'll tell you straight."
  }
];
